// trigger the content item modal on elements with class .modal-link
// attrs:
// searcher -> specify the examine searcher to poll. ie search, internal, config etc
// field -> defaults to bodyText if omitted, otherwise can be used to specify the content to return
// item-id -> the id of the node to retrieve
// wide -> does not require a value, including the attribute name adds the class 'modal-wide' to the modal-dialog element
// hide-header -> renders a modal with no header element, therefore removing the header text and image, if any exists
export default function contentModalLinkDir(contentService, $uibModal, $timeout) {
    var modalLink = {
        restrict: 'A',
        modalTemplate: 
            `<div class="modal-header" ng-if="!modal.hideHeader">
                <div class="lazywrap mb-0" aspect="square" ng-if="modal.image">
                    <img class="lazyload" ng-if="modal.image" data-src="{{ ::modal.image }}?width=250&height=250&mode=crop" />
                </div>
                <h3 class="modal-title" ng-bind="::modal.name"></h3>
            </div>
            <div class="modal-body" ng-class="{ \'hide-header\' : modal.hideHeader }">
                <div ng-bind-html="::modal.content"></div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-close" ng-click="modal.ok()" aria-label="close">CLOSE</button>
            </div>`,
        link: link
    };

    function link(scope, element, attrs) {

        var t, q;
        q = {
            searchType: attrs.searcher ? attrs.searcher + 'Searcher' : 'searchSearcher',
            html: true,
            query: {
                id: attrs.itemId
            },
            fields: attrs.field ? [attrs.field] : ['bodyText']
        };

        if (attrs.type) {
            q.contentTypes = attrs.type.split(',')
        }

        element.bind('click', e => {
            e.preventDefault();

            if (!t) {
                t = $timeout(() => {
                    contentService.get(q)
                        .then(r => {
                            showModal(r[0]);
                            $timeout.cancel(t);
                            t = undefined;
                        });
                }, 200);
            }
        });

        function showModal(item) {

            // not all node types have their main image indexed, so fall back to the attribute value
            if (!item.image && attrs.image) {
                item.image = attrs.image;
            }

            var modalInstance = $uibModal.open({
                template: modalLink.modalTemplate,
                controller: 'contentModalController as modal',
                windowClass: 'content-item-modal',
                size: attrs.wide !== undefined ? 'wide' : '',
                resolve: {
                    item: () => item,                    
                    content: () =>item[q.fields[0]],
                    hideHeader: () => attrs.hideHeader !== undefined                    
                }
            });

            modalInstance.opened.then(() => document.body.classList.add('content-item-modal-open')),

            modalInstance.result.then(() => {}, () => document.body.classList.remove('content-item-modal-open'))            
        }
    }

    return modalLink;
};
